// extracted by mini-css-extract-plugin
export default {"divider":"byypwoPb2bZUb3VOiCRD","shippingSpeedHeader":"gLwpxZvx6Q2jTP3PzQzw","poboxWarning":"GUTL8KjXeiqEMoDbxtPL"};